import React from 'react'
import { Button, Option, Select, Stepper } from '@sede-enterprise/shell-ds-react-framework';
import usePromoteModelStatus from '../hooks/usePromoteModelStatus';

const SesnorPromoteStatus = ({ id, setSelectedSensors }) => {
    const {
        statusResults,
        loading,
        currentStep,
        steps,
        refreshStatus,
        isCompleted
    } = usePromoteModelStatus(id, setSelectedSensors);

    if (isCompleted) {
        return null;
    }
    return (
        <div className='model-promote-status'>
            <h4>Model Promotion in progress</h4>
            <div className='model-promote-content'>
                {statusResults && <Select mode='multiple' showSearch={true} value={statusResults?.sensors?.split(",")} allowClear={false}>
                    {statusResults?.sensors?.split(",")?.map((sensor, index) => (
                        <Option key={index} value={sensor}>{sensor}</Option>
                    ))}
                </Select>}
                <Stepper type="dot" current={currentStep} direction="horizontal">
                    {steps.map((step, index) => (
                        <Stepper.Step
                            key={step}
                            title={step}
                        />
                    ))}
                </Stepper>

                <Button onClick={refreshStatus} loading={loading} disabled={loading}> Refresh Status</Button>
            </div>
        </div>
    )
}

export default SesnorPromoteStatus